module.exports = __webpack_public_path__ + "img/arrow_down_2.bc686526.svg";